module.exports = __webpack_public_path__ + "img/user.6dae89c2.svg";